<template>
  <Main>
    <PageHeader :title="title" :items="breadCrumbs" />
    <router-view />
  </Main>
</template>

<script>
import Main from '@/views/layouts/main';
import PageHeader from '@/components/page-header.vue';
import appConfig from "@/app.config";
import { layoutComputed,eloadRewardsMethods  } from "@/state/helpers";
// import Swal from 'sweetalert2';

export default {
  components: {
    Main,
    PageHeader
  },
  computed: {
    ...layoutComputed
  },
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      }
    ]
  },
  methods: {
    ...eloadRewardsMethods
  },
  mounted(){
  },
  data(){
    return {}
  }
}
</script>